import FooterNavigation from './FooterNavigation';
import MainToolbar from './MainToolbar';
import ProfileProviderCard from './ProfileProviderCard';
import MeProfileConnections from './me/ProfileConnections';
import MeDatastoreConnections from './me/DatastoreConnections';

export default {
    FooterNavigation,
    MainToolbar,
    ProfileProviderCard,
    MeProfileConnections,
    MeDatastoreConnections,
};



// WEBPACK FOOTER //
// ./src/components/index.js